import { createSvgComponent } from "../../icon/createSvgComponent";
import NotificationAlarm from "@core/__generated__/icon/figma/notification-alarm.svg";
export default createSvgComponent(NotificationAlarm);